import React, { useEffect, useState } from "react";
import { Clock, Sparkles, Star } from "lucide-react";
import PageShell from "../components/PageShell";
import { fetchMirrorHours } from "../toolsApi";

export default function HorasEspejo() {
  const [filter, setFilter] = useState("todas");
  const [data, setData] = useState({ items: [], next: null, now_dr: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const r = await fetchMirrorHours(filter === "todas" ? null : filter);
        if (active) setData(r);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [filter]);

  return (
    <PageShell
      eyebrow={<><Clock className="w-3.5 h-3.5" /> Horas Espejo</>}
      title="Horas Espejo y sus Mensajes"
      subtitle="Cuando miras el reloj y ves la misma hora reflejada, el universo te envía una señal. Cada hora tiene un significado y números asociados."
      accent="purple"
    >
      {/* Hora actual + próxima */}
      <div className="grid md:grid-cols-2 gap-6 mb-10">
        <div className="bg-gradient-to-br from-purple-600 via-fuchsia-600 to-pink-500 rounded-3xl p-6 text-white shadow-2xl">
          <p className="text-xs uppercase tracking-widest text-white/80 mb-2 flex items-center gap-2">
            <Clock className="w-4 h-4" /> Hora Dominicana ahora
          </p>
          <p className="text-5xl font-extrabold" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="mirror-now">
            {data.now_dr || "--:--"}
          </p>
        </div>
        {data.next && (
          <div className="bg-white border-2 border-purple-200 rounded-3xl p-6 shadow-xl">
            <p className="text-xs uppercase tracking-widest text-purple-600 mb-2 flex items-center gap-2">
              <Sparkles className="w-4 h-4" /> Próxima hora espejo
            </p>
            <p className="text-5xl font-extrabold text-[#0e4a7a]" style={{ fontFamily: "'Playfair Display', serif" }}>
              {data.next.time}
            </p>
            <p className="text-sm text-gray-700 mt-2 leading-relaxed">{data.next.meaning}</p>
            <div className="mt-3 flex gap-2">
              {data.next.numbers.map((n) => (
                <span
                  key={n}
                  className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-fuchsia-600 text-white font-extrabold shadow"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {n}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Filtros */}
      <div className="flex justify-center gap-2 mb-8 flex-wrap">
        {[
          { v: "todas", l: "Todas" },
          { v: "espejo", l: "Espejo (HH:HH)" },
          { v: "invertida", l: "Invertidas" },
        ].map((opt) => (
          <button
            key={opt.v}
            data-testid={`mirror-filter-${opt.v}`}
            onClick={() => setFilter(opt.v)}
            className={`px-4 py-2 rounded-full text-sm font-bold transition border ${
              filter === opt.v
                ? "bg-gradient-to-r from-purple-600 to-fuchsia-600 text-white border-transparent shadow"
                : "bg-white text-purple-600 border-purple-200 hover:bg-purple-50"
            }`}
          >
            {opt.l}
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading && data.items.length === 0 ? (
        <div className="text-center py-12 text-gray-500">Cargando horas...</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((h) => (
            <div
              key={h.time}
              data-testid={`mirror-card-${h.time}`}
              className="bg-white rounded-2xl border border-purple-100 shadow-md hover:shadow-xl transition overflow-hidden"
            >
              <div className="bg-gradient-to-r from-purple-600 to-fuchsia-600 p-5 text-white flex items-center justify-between">
                <p className="text-3xl font-extrabold" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {h.time}
                </p>
                <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded-full ${
                  h.kind === "espejo" ? "bg-white/20" : "bg-yellow-300/30 text-yellow-100"
                }`}>
                  {h.kind === "espejo" ? "Espejo" : "Invertida"}
                </span>
              </div>
              <div className="p-5">
                <p className="text-sm text-gray-700 leading-relaxed mb-4">{h.meaning}</p>
                <div className="flex items-center gap-2 flex-wrap">
                  <Star className="w-3.5 h-3.5 text-purple-600" />
                  {h.numbers.map((n) => (
                    <span
                      key={n}
                      className="inline-flex items-center justify-center min-w-[36px] h-9 px-2 rounded-lg bg-gradient-to-br from-purple-100 to-fuchsia-100 text-purple-700 font-extrabold text-sm border border-purple-200"
                    >
                      {n}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </PageShell>
  );
}
